export const LEDGER_REPORT_REQUEST = 'LEDGER_REPORT_REQUEST';
export const LEDGER_BY_PARTY_REPORT_REQUEST = 'LEDGER_BY_PARTY_REPORT_REQUEST';
export const LEDGER_BY_PARTY_REPORT_FAILURE = 'LEDGER_BY_PARTY_REPORT_FAILURE';
export const LEDGER_REPORT_FAILURE = 'LEDGER_REPORT_FAILURE';
export const SET_LEDGER_PARTIES = 'SET_LEDGER_PARTIES';
export const SET_LEDGER_BY_PARTY = 'SET_LEDGER_BY_PARTY';
export const SET_LEDGER_BY_SCHEDULE = 'SET_LEDGER_BY_SCHEDULE';
export const LEDGER_REPORT_SCHEDULE_REQUEST = 'LEDGER_REPORT_SCHEDULE_REQUEST';
export const SET_TRIAL_BALANCE_SCHEDULE_PARTIES = 'SET_TRIAL_BALANCE_SCHEDULE_PARTIES';
export const SET_TRADING_ACCOUNT_PARTIES = 'SET_TRADING_ACCOUNT_PARTIES';
export const SET_PROFIT_LOSS_ACCOUNT = 'SET_PROFIT_LOSS_ACCOUNT';
export const SET_BALANCE_SHEET = 'SET_BALANCE_SHEET';
export const UPDATE_LEDGER_STATUS_REQUEST = 'UPDATE_LEDGER_STATUS_REQUEST';
export const UPDATE_LEDGER_STATUS = 'UPDATE_LEDGER_STATUS';
export const UPDATE_LEDGER_STATUS_FAILURE = 'UPDATE_LEDGER_STATUS_FAILURE';
export const LEDGER_REPORT_REQUEST_FAILURE = 'LEDGER_REPORT_REQUEST_FAILURE';
export const LEDGER_REPORT_REQUEST_SUCCESS = 'LEDGER_REPORT_REQUEST_SUCCESS';